/* MIACO Theme – Interaktionen
   Menü, Videos, Scroll-Szenen (Intro, Made in Germany, Lichtszene), Farbwahl,
   Merkliste, Warenkorb (Shopify AJAX API) und Produktseite. */
(function(){
  'use strict';
  var M=window.MIACO||{routes:{root:'/',cart:'/cart',cartAdd:'/cart/add',cartChange:'/cart/change'},moneyFormat:'{{amount_with_comma_separator}} €'};
  var root=document.documentElement;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(id){return document.getElementById(id)}
  function clamp(v){return v<0?0:v>1?1:v}
  function ramp(p,a,b){return clamp((p-a)/(b-a))}
  function ease(t){return t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2}
  function esc(t){return String(t==null?'':t).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function store(k,v){try{if(v===undefined){return JSON.parse(localStorage.getItem(k)||'null')}localStorage.setItem(k,JSON.stringify(v))}catch(e){return null}}

  /* ===== Geld formatieren nach dem Shopify-Format des Shops ===== */
  function money(cents){
    var fmt=M.moneyFormat||'{{amount_with_comma_separator}} €';
    function sep(n,d,t,dec){n=(n/100).toFixed(d);var p=n.split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,t);return p[1]?p[0]+dec+p[1]:p[0]}
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
      switch(k){
        case 'amount':return sep(cents,2,',','.');
        case 'amount_no_decimals':return sep(cents,0,',','.');
        case 'amount_with_comma_separator':return sep(cents,2,'.',',');
        case 'amount_no_decimals_with_comma_separator':return sep(cents,0,'.',',');
        case 'amount_with_apostrophe_separator':return sep(cents,2,"'",'.');
        default:return sep(cents,2,'.',',');
      }
    });
  }

  /* ===== Header & Menü ===== */
  var head=$('site');
  function headerH(){var h=head?head.getBoundingClientRect().height:0;root.style.setProperty('--hh',h+'px');return h}
  var HH=headerH();
  if(head){var onScroll=function(){head.classList.toggle('scrolled',window.scrollY>10)};window.addEventListener('scroll',onScroll,{passive:true});onScroll()}
  var menu=$('menu'),openB=$('openMenu'),closeB=$('closeMenu');
  function closeMenu(focusBack){if(!menu)return;menu.classList.remove('open');document.body.classList.remove('locked');openB.setAttribute('aria-expanded','false');if(focusBack)openB.focus()}
  if(menu&&openB&&closeB){
    openB.addEventListener('click',function(){menu.classList.add('open');document.body.classList.add('locked');openB.setAttribute('aria-expanded','true');setTimeout(function(){closeB.focus()},50)});
    closeB.addEventListener('click',function(){closeMenu(true)});
    menu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){closeMenu(false)})});
  }

  /* ===== Videos: Pause-Buttons ===== */
  function initVideos(scope){
    (scope||document).querySelectorAll('.vtoggle').forEach(function(btn){
      if(btn.dataset.bound)return;btn.dataset.bound='1';
      var v=btn.parentNode.querySelector('video');if(!v)return;
      v.muted=true;v.setAttribute('playsinline','');
      function sync(){btn.classList.toggle('paused',v.paused);btn.setAttribute('aria-label',v.paused?'Video abspielen':'Video pausieren')}
      btn.addEventListener('click',function(){if(v.paused){var r=v.play();if(r&&r.catch)r.catch(function(){})}else{v.pause()}});
      v.addEventListener('play',sync);v.addEventListener('pause',sync);
      if(reduce){v.removeAttribute('autoplay');v.pause()}
      sync();
    });
  }

  /* ===== Scroll-Szenen ===== */
  function progress(el){var r=el.getBoundingClientRect(),vh=window.innerHeight-HH;var total=el.offsetHeight-vh;return total>0?clamp((HH-r.top)/total):0}
  var LIGHTS={
    kalt:   {h:[226,238,255], hs:.95, a:[150,190,255], as:.30, css:'saturate(.5) brightness(1.06)'},
    neutral:{h:[255,241,226], hs:.70, a:[255,236,214], as:.06, css:'saturate(.78)'},
    warm:   {h:[255,184,110], hs:.40, a:[255,168,90],  as:.16, css:'saturate(1.08) sepia(.12)'}
  };
  var S={};
  function initScenes(){
    S.intro=$('intro');S.made=$('madeCard');S.story=$('licht');S.lt=$('ltWrap');
    S.canvas=$('seqCanvas');
    if(S.canvas&&!S.canvas.dataset.bound){
      S.canvas.dataset.bound='1';
      S.ctx=S.canvas.getContext('2d');S.frames=[];
      try{S.frames=JSON.parse($('seqData').textContent)}catch(e){}
      S.current=0;S.drawn=false;S.maskOK=true;S.lightMode='warm';
      S.tint={h:LIGHTS.warm.h.slice(),hs:LIGHTS.warm.hs,a:LIGHTS.warm.a.slice(),as:LIGHTS.warm.as};
      S.maskC=document.createElement('canvas');S.maskX=S.maskC.getContext('2d',{willReadFrequently:true});
      S.imgs=S.frames.map(function(src,i){
        var im=new Image();im.decoding='async';im.crossOrigin='anonymous';
        im.onload=function(){if(i===S.current||!S.drawn)draw(S.current)};
        im.onerror=function(){if(!im._retry){im._retry=1;im.removeAttribute('crossorigin');im.src=src+(src.indexOf('?')<0?'?':'&')+'nc=1'}};
        im.src=src;return im});
      if(!S.frames.length)S.story.classList.add('no-canvas');
      sizeCanvas();
    }
  }
  function sizeCanvas(){if(!S.canvas)return;var dpr=Math.min(window.devicePixelRatio||1,2);S.canvas.width=Math.round(S.canvas.clientWidth*dpr);S.canvas.height=Math.round(S.canvas.clientHeight*dpr);draw(S.current)}
  function nearestLoaded(i){var a=S.imgs||[];for(var d=0;d<a.length;d++){var x=a[i-d],y=a[i+d];if(x&&x.complete&&x.naturalWidth)return x;if(y&&y.complete&&y.naturalWidth)return y}return null}
  function smooth(e0,e1,x){var t=clamp((x-e0)/(e1-e0));return t*t*(3-2*t)}
  function draw(i){
    if(!S.canvas)return;var im=nearestLoaded(i);if(!im||!S.canvas.width)return;
    var ctx=S.ctx,cw=S.canvas.width,ch=S.canvas.height,sc=Math.max(cw/im.naturalWidth,ch/im.naturalHeight);
    var w=im.naturalWidth*sc,h=im.naturalHeight*sc,x=(cw-w)/2,y=(ch-h)/2;
    ctx.globalCompositeOperation='source-over';ctx.globalAlpha=1;ctx.drawImage(im,x,y,w,h);S.drawn=true;
    if(!S.maskOK)return;
    try{
      var mw=Math.max(40,Math.round(cw/6)),mh=Math.max(40,Math.round(ch/6));
      if(S.maskC.width!==mw||S.maskC.height!==mh){S.maskC.width=mw;S.maskC.height=mh}
      S.maskX.clearRect(0,0,mw,mh);S.maskX.drawImage(im,x/6,y/6,w/6,h/6);
      var d=S.maskX.getImageData(0,0,mw,mh),px=d.data,t=S.tint,hs=t.hs*255;
      for(var k=0;k<px.length;k+=4){var L=(px[k]*.299+px[k+1]*.587+px[k+2]*.114)/255;var al=smooth(.34,.86,L);px[k]=t.h[0];px[k+1]=t.h[1];px[k+2]=t.h[2];px[k+3]=al*hs}
      S.maskX.putImageData(d,0,0);
      ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';
      ctx.globalCompositeOperation='color';ctx.drawImage(S.maskC,0,0,cw,ch);
      ctx.globalCompositeOperation='soft-light';ctx.globalAlpha=t.as;ctx.fillStyle='rgb('+t.a.map(Math.round).join(',')+')';ctx.fillRect(0,0,cw,ch);
      ctx.globalCompositeOperation='source-over';ctx.globalAlpha=1;
    }catch(err){S.maskOK=false;ctx.globalCompositeOperation='source-over';ctx.globalAlpha=1;S.canvas.style.filter=LIGHTS[S.lightMode].css;ctx.drawImage(im,x,y,w,h)}
  }
  var anim=null;
  function setLight(mode){
    if(!LIGHTS[mode]||!S.canvas)return;S.lightMode=mode;var L=LIGHTS[mode];
    document.querySelectorAll('[data-light]').forEach(function(b){var on=b.dataset.light===mode;b.classList.toggle('on',on);b.setAttribute('aria-pressed',on)});
    if(!S.maskOK){S.canvas.style.filter=L.css;return}
    var from={h:S.tint.h.slice(),hs:S.tint.hs,a:S.tint.a.slice(),as:S.tint.as},t0=performance.now(),dur=reduce?1:520;
    if(anim)cancelAnimationFrame(anim);
    (function step(now){var t=Math.min(1,(now-t0)/dur),e=ease(t);
      for(var j=0;j<3;j++){S.tint.h[j]=from.h[j]+(L.h[j]-from.h[j])*e;S.tint.a[j]=from.a[j]+(L.a[j]-from.a[j])*e}
      S.tint.hs=from.hs+(L.hs-from.hs)*e;S.tint.as=from.as+(L.as-from.as)*e;draw(S.current);
      if(t<1)anim=requestAnimationFrame(step);else anim=null})(t0);
  }
  function update(){
    if(reduce)return;
    var narrow=window.innerWidth<=820;
    if(S.intro&&S.intro.isConnected){
      var p=progress(S.intro);
      S.intro.style.setProperty('--fade',ease(ramp(p,.08,.55)).toFixed(3));
      S.intro.style.setProperty('--info',ease(ramp(p,.3,.7)).toFixed(3));
      S.intro.style.setProperty('--lift',ease(ramp(p,.05,.6)).toFixed(3));
    }
    if(S.made&&S.made.isConnected){
      var r=S.made.getBoundingClientRect(),vh=window.innerHeight,m=ease(clamp((vh-r.top)/(vh*0.85)));
      S.made.style.setProperty('--sc',(0.9+0.1*m).toFixed(4));
      S.made.style.setProperty('--r',(32-16*m).toFixed(1)+'px');
    }
    if(S.story&&S.story.isConnected&&S.lt){
      var q=progress(S.story);
      S.story.style.setProperty('--p',q.toFixed(4));
      S.story.style.setProperty('--t',ease(ramp(q,0,.24)).toFixed(3));
      S.story.style.setProperty('--to',(1-ramp(q,.16,.27)).toFixed(3));
      var bIn=ramp(q,.17,.3),b=ease(bIn)*(1-ramp(q,.93,1));
      S.lt.style.setProperty('--b',b.toFixed(3));
      S.lt.style.setProperty('--by',((1-ease(bIn))*24-ease(ramp(q,.62,1))*(narrow?14:12)).toFixed(2));
      S.lt.classList.toggle('live',b>.4);
      S.story.style.setProperty('--f',ease(ramp(q,.46,.6)).toFixed(3));
      if(S.frames&&S.frames.length){var idx=Math.round(q*(S.frames.length-1));if(idx!==S.current||!S.drawn){S.current=idx;draw(idx)}}
    }
  }
  var ticking=false;
  window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(function(){ticking=false;update()})}},{passive:true});
  window.addEventListener('resize',function(){HH=headerH();sizeCanvas();update()});

  /* ===== Startseite: Farbwahl auf den Produktkarten ===== */
  function initCards(scope){
    (scope||document).querySelectorAll('.pcard').forEach(function(card){
      if(card.dataset.bound)return;card.dataset.bound='1';
      var main=card.querySelector('.p-main'),roomImg=card.querySelector('.p-room'),label=card.querySelector('.p-color'),link=card.querySelector('.p-media');
      card.querySelectorAll('.sw').forEach(function(sw){
        sw.addEventListener('click',function(){
          card.querySelectorAll('.sw').forEach(function(x){x.classList.toggle('on',x===sw);x.setAttribute('aria-pressed',x===sw)});
          if(main&&sw.dataset.img){main.src=sw.dataset.img;main.alt=main.alt.replace(/ in .*$/,' in '+sw.dataset.name)}
          if(label)label.textContent=sw.dataset.name;
          if(link&&sw.dataset.url)link.href=sw.dataset.url;
          if(roomImg){if(sw.dataset.room){roomImg.src=sw.dataset.room;card.classList.add('has-room')}else{card.classList.remove('has-room')}}
        });
      });
    });
  }

  /* ===== Merkliste (nur in diesem Browser) ===== */
  var wish=store('miaco-wish')||{};
  Object.keys(wish).forEach(function(k){if(!wish[k]||typeof wish[k]!=='object')delete wish[k]});  // alte Einträge ohne Daten entfernen
  function wishCount(){var n=Object.keys(wish).length;document.querySelectorAll('.wishcount').forEach(function(el){el.textContent=n;el.hidden=!n})}
  function initWish(scope){(scope||document).querySelectorAll('[data-wish]').forEach(function(w){w.setAttribute('aria-pressed',wish[w.dataset.wish]?'true':'false')});wishCount()}
  function syncHearts(){document.querySelectorAll('[data-wish]').forEach(function(w){w.setAttribute('aria-pressed',wish[w.dataset.wish]?'true':'false')})}
  function toggleWish(btn){
    var id=btn.dataset.wish;
    if(wish[id]){delete wish[id]}
    else wish[id]={id:id,title:btn.dataset.wTitle||'',color:btn.dataset.wColor||'',price:btn.dataset.wPrice||'',url:btn.dataset.wUrl||'',img:btn.dataset.wImg||'',handle:btn.dataset.wHandle||'',t:Date.now()};
    store('miaco-wish',wish);syncHearts();wishCount();if(wishEl&&wishEl.classList.contains('open'))renderWish();
  }
  var wishEl=$('wish'),wishVeil=$('wishVeil');
  function renderWish(){
    var box=$('wishItems');if(!box)return;
    var items=Object.keys(wish).map(function(k){return wish[k]}).sort(function(a,b){return (b.t||0)-(a.t||0)});
    if(!items.length){box.innerHTML='<p class="cart-empty"><b>Noch nichts gemerkt.</b>Tippe bei einer Leuchte auf das Herz, dann landet sie hier.</p>';return}
    box.innerHTML=items.map(function(it){
      return '<div class="citem"><a href="'+esc(it.url)+'">'+(it.img?'<img src="'+esc(it.img)+'" alt="" width="72" height="88">':'')+'</a>'+
        '<div><b><a href="'+esc(it.url)+'">'+esc(it.title)+'</a></b><small>'+esc(it.color)+'</small>'+
        '<div class="w-actions">'+(it.available===false?'<span class="s-add" aria-disabled="true">Ausverkauft</span>':'<button type="button" class="s-add" data-wadd="'+esc(it.id)+'">In den Warenkorb</button>')+
        '<button type="button" class="crm" data-wrm="'+esc(it.id)+'">Entfernen</button></div></div>'+
        '<span class="cprice">'+esc(it.price)+'</span></div>'}).join('');
  }
  function refreshWish(){
    var handles={};Object.keys(wish).forEach(function(k){if(wish[k].handle)handles[wish[k].handle]=1});
    Object.keys(handles).forEach(function(h){
      fetch((M.routes.root||'/').replace(/\/$/,'')+'/products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null}).then(function(p){
        if(!p)return;var changed=false;
        p.variants.forEach(function(v){var w=wish[v.id];if(!w)return;var pr=money(v.price);if(w.price!==pr||w.available!==v.available){w.price=pr;w.available=v.available;changed=true}});
        if(changed){store('miaco-wish',wish);renderWish()}
      }).catch(function(){});
    });
  }
  function openWish(){if(!wishEl)return;if(cartEl&&cartEl.classList.contains('open'))closeCart();renderWish();refreshWish();wishVeil.hidden=false;wishEl.classList.add('open');wishEl.setAttribute('aria-hidden','false');document.body.classList.add('locked');setTimeout(function(){$('wishClose').focus()},60)}
  function closeWish(){if(!wishEl)return;wishEl.classList.remove('open');wishEl.setAttribute('aria-hidden','true');wishVeil.hidden=true;document.body.classList.remove('locked')}

  /* ===== Warenkorb (Shopify AJAX API) ===== */
  var cartEl=$('cart'),veil=$('cartVeil'),thumbs=store('miaco-thumbs')||{};
  function rememberThumb(id,url){if(id&&url){thumbs[id]=url;store('miaco-thumbs',thumbs)}}
  function api(url,body){return fetch(url,{method:body?'POST':'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},body:body?JSON.stringify(body):undefined,credentials:'same-origin'}).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})}
  function renderCart(cart){
    document.querySelectorAll('.cartcount').forEach(function(el){el.textContent=cart.item_count});
    var box=$('cartItems');if(!box)return;
    if(!cart.items.length){box.innerHTML='<p class="cart-empty">Dein Warenkorb ist noch leer.</p>'}
    else box.innerHTML=cart.items.map(function(it,i){
      var img=it.image||thumbs[it.variant_id]||'';
      if(it.image&&it.image.indexOf('cdn')>-1&&it.image.indexOf('width=')<0)img=it.image+(it.image.indexOf('?')<0?'?':'&')+'width=200';
      var vt=(it.variant_title&&it.variant_title!=='Default Title')?it.variant_title:'';
      return '<div class="citem">'+(img?'<img src="'+esc(img)+'" alt="" width="72" height="88">':'<span></span>')+
        '<div><b><a href="'+esc(it.url)+'">'+esc(it.product_title)+'</a></b><small>'+esc(vt)+'</small>'+
        '<div class="cqty"><button type="button" data-line="'+(i+1)+'" data-qty="'+(it.quantity-1)+'" aria-label="Weniger">−</button><span>'+it.quantity+'</span><button type="button" data-line="'+(i+1)+'" data-qty="'+(it.quantity+1)+'" aria-label="Mehr">+</button></div>'+
        '<button type="button" class="crm" data-line="'+(i+1)+'" data-qty="0">Entfernen</button></div>'+
        '<span class="cprice">'+money(it.final_line_price)+'</span></div>'}).join('');
    var tot=$('cartTotal');if(tot)tot.textContent=money(cart.total_price);
    var co=$('cartCheckout');if(co)co.disabled=!cart.item_count;
  }
  function refreshCart(){return api(M.routes.cart+'.js').then(renderCart).catch(function(){})}
  function openCart(){if(!cartEl)return;refreshCart();veil.hidden=false;cartEl.classList.add('open');cartEl.setAttribute('aria-hidden','false');document.body.classList.add('locked');setTimeout(function(){$('cartClose').focus()},60)}
  function closeCart(){if(!cartEl)return;cartEl.classList.remove('open');cartEl.setAttribute('aria-hidden','true');veil.hidden=true;document.body.classList.remove('locked')}
  function addToCart(id,qty,thumb,btn){
    rememberThumb(id,thumb);
    if(btn){btn.disabled=true}
    return api(M.routes.cartAdd+'.js',{items:[{id:+id,quantity:qty||1}]}).then(function(){
      if(btn){btn.disabled=false;btn.classList.add('done');var old=btn.dataset.label||btn.textContent;btn.dataset.label=old;btn.innerHTML='<svg><use href="#i-check"/></svg>Im Warenkorb';setTimeout(function(){btn.classList.remove('done');btn.textContent=old},1600)}
      return refreshCart().then(openCart);
    }).catch(function(err){if(btn)btn.disabled=false;alertInline(btn,(err&&(err.description||err.message))||'Das hat nicht geklappt. Bitte versuch es noch einmal.')});
  }
  function alertInline(btn,msg){if(!btn)return;var p=btn.parentNode.querySelector('.add-err');if(!p){p=document.createElement('p');p.className='add-err';btn.parentNode.appendChild(p)}p.textContent=msg;setTimeout(function(){p.remove()},5000)}
  if(cartEl){
    var co=$('cartOpen');if(co)co.addEventListener('click',function(e){e.preventDefault();openCart()});
    $('cartClose').addEventListener('click',closeCart);veil.addEventListener('click',closeCart);
  }
  if(wishEl){
    var wo=$('wishOpen');if(wo)wo.addEventListener('click',function(e){e.preventDefault();openWish()});
    $('wishClose').addEventListener('click',closeWish);wishVeil.addEventListener('click',closeWish);
  }
  document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;if(wishEl&&wishEl.classList.contains('open'))closeWish();else if(cartEl&&cartEl.classList.contains('open'))closeCart();else if(menu&&menu.classList.contains('open'))closeMenu(true)});

  /* ===== Klicks: Lichtfarbe, Merken, In den Warenkorb, Menge ===== */
  document.addEventListener('click',function(e){
    var l=e.target.closest('[data-light]');if(l){setLight(l.dataset.light);return}
    var w=e.target.closest('[data-wish]');if(w){toggleWish(w);return}
    var wa=e.target.closest('[data-wadd]');if(wa){var it=wish[wa.dataset.wadd];closeWish();addToCart(wa.dataset.wadd,1,it&&it.img,null);return}
    var wr=e.target.closest('[data-wrm]');if(wr){delete wish[wr.dataset.wrm];store('miaco-wish',wish);syncHearts();wishCount();renderWish();return}
    var a=e.target.closest('[data-add]');if(a){addToCart(a.dataset.add,1,a.dataset.thumb,a);return}
    var c=e.target.closest('[data-line]');
    if(c){api(M.routes.cartChange+'.js',{line:+c.dataset.line,quantity:+c.dataset.qty}).then(renderCart).catch(function(){});return}
  });

  /* ===== Produktseite ===== */
  function initPDP(){
    var form=$('pdpForm'),dataEl=$('pdpData');if(!form||!dataEl||form.dataset.bound)return;form.dataset.bound='1';
    var V=[];try{V=JSON.parse(dataEl.textContent)}catch(e){}
    var input=$('pdpVariant'),qty=$('pdpQty'),add=$('pdpAdd');
    function byId(id){return V.filter(function(v){return v.id==id})[0]}
    function select(id){
      var v=byId(id);if(!v)return;input.value=v.id;
      document.querySelectorAll('[data-variant]').forEach(function(b){var on=b.dataset.variant==id;b.classList.toggle('on',on);b.setAttribute('aria-pressed',on)});
      if($('pdpColor'))$('pdpColor').textContent=v.name;
      if($('pdpPrice'))$('pdpPrice').textContent=v.price;
      if($('pdpMain')&&v.img){$('pdpMain').src=v.img;$('pdpMain').alt=$('pdpMain').alt.replace(/ in .*$/,' in '+v.name)}
      if($('pdpRoom')&&v.room)$('pdpRoom').src=v.room;
      add.disabled=!v.available;add.textContent=v.available?'In den Warenkorb':'Ausverkauft';
      var ph=$('pdpWish');if(ph){ph.dataset.wish=v.id;ph.dataset.wColor=v.name;ph.dataset.wPrice=v.price;ph.dataset.wUrl=v.url;ph.dataset.wImg=v.img||'';ph.setAttribute('aria-pressed',wish[v.id]?'true':'false')}
      try{history.replaceState(null,'',v.url)}catch(e){}
    }
    document.querySelectorAll('[data-variant]').forEach(function(b){b.addEventListener('click',function(){select(b.dataset.variant)})});
    form.querySelectorAll('[data-step]').forEach(function(b){b.addEventListener('click',function(){qty.value=Math.max(1,(+qty.value||1)+(+b.dataset.step))})});
    form.addEventListener('submit',function(e){
      if(!cartEl)return;e.preventDefault();var v=byId(input.value);
      addToCart(input.value,Math.max(1,+qty.value||1),v&&v.img,add);
    });
  }

  /* ===== Start ===== */
  function init(scope){initVideos(scope);initScenes();initCards(scope);initWish(scope);initPDP();HH=headerH();sizeCanvas();update()}
  init();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
